import {Store,Module,ActionContext} from 'vuex'
import ListModule from '../list-module'
import ListState from '../list-state'
import Employee from '../../entities/admin/employee'
import Ajax from '../../../lib/ajax'
import Util from '../../../lib/util'

interface EmployeeState extends ListState<Employee>{
    editModel:Employee;
    
}
class EmployeeModule extends ListModule<EmployeeState,any,Employee>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize: 10,
        list: new Array<Employee>(),
        loading:false,
        editModel: new Employee(),
        activeList: new Array<Employee>(),
        path: 'employees'          
    }
    actions = Util.extend(true, this.base_actions, {
        //extra actions        
    });
    mutations = Util.extend(true, this.base_mutations, {
        //extra mutations
    });
}
const employeeModule=new EmployeeModule();
export default employeeModule;
